<template>
    <main-layout>
        <!--<p>NUM OTAG : {{ otag }}</p>-->
    </main-layout>
</template>

<script>
import Bouteille from "../../js/models/Bouteille"
import localforage from "localforage";

export default {
    data(){
        return {

        }
    },
    computed: {
        otag(){
            return this.$route.params.str
        }
    },
    async beforeCreate(){

        let str = this.$route.params.str;
        let addBouteille = null
        if(typeof this.$route.params.bouteille != "undefined") {
            addBouteille = this.$route.params.bouteille;
        }
        let strValid = true;
        let tab = [];

        if( !_.includes(str, '-')){
            strValid = false
        } else {
            tab = str.split('-');
            if(tab.length !== 2){
                strValid = false
            }

            //Si premier otag plus grand que 2 chiffre xx-xxxxx
            if(tab[0].length > 2){
                strValid = false
            }

            if(isNaN(tab[0]) || isNaN(tab[1])){
                strValid = false
            }

        }

        if(strValid) {
            let otags = JSON.parse( await localforage.getItem('OTAGS'));

            if(otags.indexOf(tab[0]+'-'+tab[1]) !== -1){

                swal('OTAG utilisé', "Cette puce OTAG ("+tab[0]+'-'+tab[1]+") a déjà été utilisée.", 'error').then(this.$router.push({name:'home'}))

            } else {

                let router = this.$router;



                Bouteille
                    .getBouteilleByTag( parseInt(tab[0]), tab[1] )
                    .then(bouteille => {
                        //Bouteille existante
                        this.$router.push({ name: 'bouteille', params: {id: bouteille.id}, query: {scan: true} })
                    })
                    .catch(() => {
                        //Bouteille inexistante

                        if(addBouteille != null) {
                            Bouteille.getBouteille(addBouteille)
                                .then(async bouteille => {
                                    if(bouteille.key1 === null && bouteille.key2 === null && bouteille.otag === null) {

                                        bouteille.key1 = tab[0];
                                        bouteille.key2 = tab[1];
                                        bouteille.otag = tab[0] + '-' + tab[1];
                                        await Bouteille.updateBouteille(bouteille.id, bouteille).then(
                                            function () {
                                                router.push({ name: 'bouteille', params: {id: bouteille.id}, query: {scan: true, addOtag: true} })
                                            },
                                            () => swal('Erreur', 'Une erreur est survenue lors de la modification de la bouteille', 'error')
                                        )
                                    }else{
                                        swal('Erreur', 'Cette bouteille a déjà une otag', 'error').then(
                                            () => router.push({ name: 'bouteille', params: {id: bouteille.id} })
                                        )
                                    }

                                })
                            //router.push({ name: 'bouteille', params:{id: addBouteille}, query: {key1:tab[0], key2: tab[1], scan: true} });
                            return;
                        }

                        let type = null;
                        let html = "";

                        html += '<div class="relative flex flex-col gap-3 w-full">';
                        html += '<i class="absolute -top-16 -right-4 inline-block h-8 w-8 mask mask-close-circle bg-alert cursor-pointer hover:bg-gray-600 transition-colors z-10" onclick="swal.clickConfirm()" id="returnBack"></i>';
                        html += '<button class="block w-full text-center bg-gaz-ff text-white font-semibold py-4 rounded transition-colors text-lg" onclick="swal.clickConfirm()" id="btFf">Fluide Frigorigène</button>';
                        html += '<button class="block w-full text-center bg-gaz-rec text-white font-semibold py-4 rounded transition-colors text-lg" onclick="swal.clickConfirm()" id="btR">Récupération</button>';
                        html += '<button class="block w-full text-center bg-gaz-tf text-white font-semibold py-4 rounded transition-colors text-lg" onclick="swal.clickConfirm()" id="btT">Transfert</button>';
                        html += '</div>';

                        swal({
                            title: 'Type bouteille',
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            html
                        })

                        function goToRoute(tab, type, others) {
                            let location = null;
                            if(typeof others !== 'undefined'){
                                if(typeof others.code !== 'undefined' && others.code !== null){
                                    location = { name: 'new-bouteille', query: {key1:tab[0], key2: tab[1], scan: true, type: type, wantScan: others.wantScan, code: others.code } };
                                }else{
                                    location = { name: 'new-bouteille', query: {key1:tab[0], key2: tab[1], scan: true, type: type, wantScan: others.wantScan} };
                                }
                            }else{
                                location = { name: 'new-bouteille', query: {key1:tab[0], key2: tab[1], scan: true, type: type} };
                            }
                            router.push(location);
                        }

                        let returnBack = document.getElementById('returnBack');
                        let btFf = document.getElementById('btFf');
                        let btR = document.getElementById('btR');
                        let btT = document.getElementById('btT');

                        btFf.onclick = function () {
                            swal.clickConfirm();
                            type = 'Fluide frigorigène'
                            goToRoute(tab, type);
                        }

                        returnBack.onclick = function () {
                            swal.clickConfirm();
                            router.push({ name: 'liste-bouteilles' });
                        }

                        function displayCodeBouteille(tab, type) {
                            html = '<div class="flex flex-col gap-4 w-full">';
                            html += '<button class="block w-full text-center bg-black text-white font-semibold py-4 rounded transition-colors text-lg flex items-center justify-center gap-2" id="scanCodeBarre">';
                            html += '<i class="inline-block h-6 w-6 mask mask-otag bg-white flex-shrink-0"></i>';
                            html += '<span class="flex items-center">SCAN CODE BARRE</span>';
                            html += '</button>';
                            html += '<input title="code" id="codeBt" placeholder="Code bouteille" type="text" maxLength="255" class="input w-full">';
                            html += '<button class="btn-primary text-lg py-4" id="validFromCodeBouteille">Valider</button>';
                            html += '</div>';

                            swal({
                                title: 'Saisissez le numéro bouteille ou scanner le code barre',
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                html
                            })

                            let btScanCodeBarre = document.getElementById('scanCodeBarre');
                            let btnValidFromCodeBouteille = document.getElementById('validFromCodeBouteille');

                            btScanCodeBarre.onclick = function () {
                                swal.clickConfirm();
                                goToRoute(tab, type, { wantScan: true });
                            }

                            btnValidFromCodeBouteille.onclick = function () {
                                swal.clickConfirm();
                                //console.log(document.getElementById('codeBt').value)
                                goToRoute(tab, type, { code: document.getElementById('codeBt').value });
                            }


                        }

                        btR.onclick = function () {
                            swal.clickConfirm();
                            type = 'Récupération'


                            displayCodeBouteille(tab, type);


                        }

                        btT.onclick = function () {
                            swal.clickConfirm();
                            type = 'Transfert'


                            displayCodeBouteille(tab, type);

                        }



                    })
            }

        } else {
            let router = this.$router;
            swal('Tag invalide', "Ce tag NFC n'est pas un scan OTAG", 'error').then(function(){
                router.push({name:'liste-bouteilles'})
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// ScanOtag.vue?20204b2e